                                                     
import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      <p class="mb-3 bold">
        I. ПРОКЛЯТЬЕ СТАРОСТИ
      </p>
      
      <p class="mb-3">
        Как это понимать? 
        Что старость – это проклятье? 
        Или что старость проклинает всё, что не старо, что не готовится к концу? 
      </p>
      
      <p class="mb-3">
        К сожалению, верны оба толкования. 
      </p>
      
      <p class="mb-3">
        Старость безжалостна. Она уродует, уничтожает, портит людей, отнимает у них лучшее, что было, и подчёркивает, усиляет, 
        взращивает все их недостатки, показыват их в сардонически преувеличенном виде. 
        Кто был бережлив – становится омерзительно скуп (Скупой рыцарь); кто питался чистой детской верой в Бога – становится изувером-фанатиком. 
        У всех ослабевают мозги, атрофируется способность к критическому мышлению. 
        За долгую жизнь к стольким мерзостям пришлось приспособиться, со стольким смириться… 
        И привыкаешь, привыкаешь ко всему, уже ничего не вызывает ни возмущения, ни отторжения. 
        Чувства тоже засыпают и отмирают… человек звкостеневает в каком-то раннем своём состоянии; 
        у многих развитие оканчивается в 11 лет, с окончанием начальной школы; почти у всех – с началом или, в крайнем случае, 
        с концом полового созревания, т.е., со вступлением в брак. 
        Дальше идёт только «доживание» – продвижение по тем же рельсам безо всякого развития – расширения в стороны или вверх. 
      </p>
      
      <p class="mb-3">
        И лишь одно чувство растёт постоянно в течение жизни и полностью завладевает человеком к старости – <b>с т р а х</b>. 
      </p>
      
      <p class="mb-3">
        Всю жизнь ему надо было чего-то опасаться, чего-то избегать, от чего-то прятаться; и эта необходимость вошла ему в плоть и кровь, 
        стала наиболее насущной. К старости она стаёт абсолютно доминирующей, определяющей всю жизнь. 
        Всё – опасно: всё, что грозит сломать или сдвинуть существующие рамки; а поскольку жизнь меняется, то опасно ВСЁ! 
        Само движение жизни подталкивает стариков к обрыву, к концу: ничего привычного не осталось, нет для тебя уже места здесь! 
      </p>
      
      <p class="mb-3">
        И кто-то покорно уходит, гонимый этим проклятьем, когда весь свет сжимается и вытесняет его. 
      </p>
      
      <p class="mb-4">
        А кто-то обращает это проклятье против окружающего мира, в бессильной злобе пытаясь унести с собой в небытие хоть что-нибудь из того, 
        что окружало его. 
        Но рано или поздно, свершит он или не свершит ещё зла, проклятье старости уносит и его. 
      </p>
      
      <p class="mb-1 text-center">
        Не избегнешь ты доли кровавой,
      </p>
      
      <p class="mb-1 text-center">
        Что земным предназначила твердь; 
      </p>
      
      <p class="mb-1 text-center">
        Но молчи! Сокровенное право – 
      </p>
      
      <p class="mb-4 text-center">
        Самому выбирать свою смерть.
      </p>

      
      <p class="mb-3 bold">
        II. БЛАГОДАТЬ СТАРОСТИ
      </p>
      
      <p class="mb-3">
        «Но в мире есть другие области…»… несколько процентов людей избегают общей доли и идут совершенно другим путём, развиваясь всю жизнь. 
        Их жизнь – не прямые горизонтальные рельсы, а высокое раскидистое дерево – живое, со многими ветвями, 
        на которых трепещут свежие зелёные листья, а вершина устремилась вверх, и растёт, растёт, пока длится жизнь. 
        Его ласкает солнце, птички поют среди ветвей; а вниз оно бросает живительную тень, где можно отдохнуть и набраться сил. 
      </p>
      
      <p class="mb-3">
        И сколько людей спасаются в тени такого дерева! Сколько доброты, сколько мудрости, 
        сколько знаний о законах природы и жизни людей передали нам старики! 
        Сколько силы почерпнули мы от них, оставшихся сильными, несмотря на угасание всех жизненных сил! 
        Сколько детей они поддержали и спасли своей мудростью и добротой, сколько людей помнят в начале жизни не родителей, 
        а бабушку или дедушку, или Учителя, открывшего путь в мире. «Светоч жизни» – так говорю я о тех стариках, что осветили мне, 
        вступающей в мир, чистый, светлый и широкий путь, который я могла бы и не найти, блуждая в хаосе и потёмках пубертатного периода. 
        Они одарили меня Благодатью. 
        Дай бог, чтобы я хоть часть этой Благодати могла передать дальше!
      </p>
      
    </div>
    `
  )
}

const itemName = {
  rus: `Проклятие старости`
}

const itemDate = {
  rus: '15 мая 2022 г.'
}
const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;